import { DaySecond, RDate, TimeRange } from "../../core";
import { makeImmutable } from "../../core/makeImmutable";
/**
 * Holidays overrides restaurant's ordering hours.
 */
export class Holiday {
    constructor(params) {
        this.startDate = params.startDate;
        this.endDate = params.endDate;
        this.timeRange = params.timeRange;
        makeImmutable(this);
    }
    static fromHolidayInfo(holidayInfo, tz) {
        const startDate = RDate.fromString(holidayInfo.startDate, tz).startOfDay();
        const endDate = RDate.fromString(holidayInfo.endDate, tz).endOfDay();
        const wholeDayInSeconds = 24 * 3600;
        const from = DaySecond.fromNumber(holidayInfo.from);
        // FIXME: if `holidayInfo.to` exceeds the boundaries of the day then we
        // reduce the time till the end of the day otherwise we would cross the
        // boundaries of the day and affect next day which could have different
        // opening hours already set
        let to;
        if (holidayInfo.to >= wholeDayInSeconds) {
            to = DaySecond.fromNumber(wholeDayInSeconds - 60);
        }
        else {
            to = DaySecond.fromNumber(holidayInfo.to);
        }
        const timeRange = TimeRange.fromRange({ from, to });
        return new Holiday({ startDate, endDate, timeRange });
    }
}
